import { TYPE_COLLECTION } from './input-types';
import { MARKETPLACE } from '../constants';

export const id = MARKETPLACE;
export const apiKey = 'MarketplaceId';
export const type = TYPE_COLLECTION;

export const marketplace = {
  id,
  apiKey,
  type,
};
